import { render } from "./Resena.vue?vue&type=template&id=3ce0d9de&scoped=true"
import script from "./Resena.vue?vue&type=script&lang=js"
export * from "./Resena.vue?vue&type=script&lang=js"

import "./Resena.vue?vue&type=style&index=0&id=3ce0d9de&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce0d9de"]])

export default __exports__